import styled from "@emotion/styled";

export const TitleStyled = styled("h2")(({ isMobile }) => ({
  fontSize: "32px",
  margin: "0 0 40px 0",
  textWrap: isMobile ? "wrap" : "nowrap",
}));
